var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiAlert from '@mui/material/Alert';
import { AlertErrorCircleIcon, AlertWarningIcon, CheckCircleIcon, InfoCircleIcon, } from '../../icons';
/**
 * Pigment [Alert](https://pigment.customink.com/?path=/docs/components-alert)
 */
var Alert = React.forwardRef(function (props, ref) { return (React.createElement(MuiAlert, __assign({ iconMapping: {
        info: React.createElement(InfoCircleIcon, { fontSize: "inherit" }),
        success: React.createElement(CheckCircleIcon, { fontSize: "inherit" }),
        warning: React.createElement(AlertWarningIcon, { fontSize: "inherit" }),
        error: React.createElement(AlertErrorCircleIcon, { fontSize: "inherit" }),
    }, ref: ref, variant: "outlined" }, props))); });
export default Alert;
//# sourceMappingURL=Alert.js.map